export default __webpack_public_path__ + "static/media/invite_friend_mobile.3cb7c1a2.png";